/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-props-no-spreading */
import { CSSProperties, useEffect, useRef } from "react";

import { useField } from "@unform/core";
import ReactInputMask from "react-input-mask";
import { Container } from "./styles";

interface IInputProps {
  label: string;
  placeholder?: string;
  maskPlaceholder?: string;
  name: string;
  required?: boolean;
  cols?: number;
  isMulti?: boolean;
  type?: string;
  onChange?: (e: any) => void;
  value?: string;
  minHeight?: string;
  style?: CSSProperties;
  mask?: any;
  isMask?: boolean;
  setValue?: any;
}

const Input: React.FC<IInputProps> = ({
  label,
  name,
  isMulti,
  children,
  minHeight,
  style,
  mask,
  isMask,
  value,
  setValue,
  maskPlaceholder,
  ...rest
}) => {
  const inputRef = useRef(null);

  const { fieldName, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: "value",
    });
  }, [fieldName, registerField]);

  return (
    <Container style={style}>
      <label>{label}</label>
      <div>
        {isMask ? (
          <ReactInputMask
            mask={mask}
            value={value}
            style={{
              minHeight,
              border:
                error === undefined
                  ? "1.2px solid #e8eaef"
                  : "1.2px solid #FB264B",
            }}
            ref={inputRef}
            placeholder={maskPlaceholder}
            onChange={e => setValue(e.target.value)}
          />
        ) : (
          <>
            {isMulti ? (
              <textarea
                style={{
                  minHeight,
                  border:
                    error === undefined
                      ? "1.2px solid #e8eaef"
                      : "1.2px solid #FB264B",
                }}
                ref={inputRef}
                name={name}
                cols={10}
                {...rest}
              />
            ) : (
              <div className="inputBox">
                <input
                  style={{
                    border:
                      error === undefined
                        ? "1.2px solid #e8eaef"
                        : "1.2px solid #FB264B",
                  }}
                  ref={inputRef}
                  name={name}
                  {...rest}
                />
                {children}
              </div>
            )}
          </>
        )}

        {error && <span className="error">{error}</span>}
      </div>
    </Container>
  );
};

export default Input;
